import styled from 'styled-components';
import ThemeHelper from '../../themes/theme-helper';
import { flexbox, flexDirection, alignItems } from '../../styles/helpers/flexbox';

const Header = styled.h2(() => `
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 16px;
`);

const ModalBody = styled.div((props) => {
  const { colours } = ThemeHelper.getTheme(props);

  return `
  ${flexbox()};
  ${flexDirection('column')};
  ${alignItems('flex-start')};

  * {
    color: ${colours.grey[900]}
  }
  `;
});

const headingStyle = `
  .heading {
    font-weight: 600;

    .asterix {
      color: red;
    }
  }
`;

const margin = 'margin-bottom: 15px;';

const Type = styled.div(() => `
  ${flexbox()};
  ${margin}

  ${headingStyle}

  .subHeading{
    padding-left: 15px;
  }
`);

const Content = styled.div(() => `
    border: 1px solid #E6E9EA;
    width: 100%;
    border-radius: 10px;
    text-align: left;
    font-size: 15px;
    ${margin}

    .assessmentDetails {
      ${flexbox()};
      border-top: 1px solid #E6E9EA;

      .detailsCont {
        width: 50%;
        padding: 10px;
          &:first-child {
            border-right: 1px solid #E6E9EA
          }
      }

      input::-webkit-outer-spin-button,
      input::-webkit-inner-spin-button {
        -webkit-appearance: none;
      }

    }

    .duration-option {
      ${alignItems('flex-start')};
    }

    .duration-length {
      & > div {
        margin-bottom: 10px;
      }

      .duration-field {
        ${flexbox()};
        ${alignItems('center')};

        .isvg {
          ${flexbox()};
          ${alignItems('center')};
          margin-left: 15px;
          cursor: pointer;
        }
      }
    }

    .randomize, .duration {
      padding: 10px;
      line-height: 20px;

      .text {
        margin: 0 15px;
        line-height: initial;
      }
    }

    ${headingStyle}

    .subHeading{
      margin: 8px 0
    }
  `);

const Preview = styled.div(() => `
  ${flexbox()};
  margin: 20px auto;

  .previewButton {
    background-color: #c3d5e1;
    border: 1px solid #c3d5e1;
    color: #3b4e5e;
    padding: 2px 25px 2px 20px;

    .isvg {
      height: 15px;
      width: 25px;
    }
  }
`);

const InfoContent = styled.div(props => `
  width: ${props.width}px;
  padding: 15px;
  box-sizing: border-box;

  p:not(:last-child) {
    margin-bottom: 15px;
  }
`);

const InputWrapper = styled.input((props) => {
  const { typography, palette } = ThemeHelper.getTheme(props);

  return `
        font-family: ${typography.family};
        font-size: 14px;
        padding: 4px;
        margin-right: 10px;
        border-radius: 5px;
        border: 1px solid #cfd2d4;
        color: ${palette.primary.dark};
        width: 30px;
        text-align: center;
        -moz-appearance: textfield;
    `;
});

const Footer = styled.div(() => `
    ${flexbox()};
    margin: auto;

    .ctrlButtons {
      display: flex;
    }

    .btn {
      margin-top: 10px;
      color: #fff;
      padding: 6px 30px;

      &.cancelBtn {
        background-color: #BB1616;
        border: 1px solid #BB1616;
        margin: 0 50px 0 0;
      }
  
      &.assignBtn {
        background-color: #3B4E5E;
        border: 1px solid #3B4E5E;
        margin: 0 0 0 50px;
      }
    }
`);

export { ModalBody, Header, Content, Preview, InputWrapper, Footer, Type, InfoContent };
